/**
 * Il testo di un errore dell'API come lo legge l'operatore.
 *
 * Sta fuori da `client.ts` perche' le verifiche girano in Node, dove il client
 * — che legge `import.meta.env` di Vite — non si carica.
 */

import type { DettaglioErrore } from "./types";

/**
 * Il messaggio con le violazioni di campo accodate.
 *
 * Una violazione che il messaggio dice gia' non si ripete: quando l'errore
 * riguarda un campo solo l'API mette lo stesso testo nel messaggio e nel
 * dettaglio, e l'operatore leggeva due volte la stessa frase — «Copia in
 * «Atti generali»: … (copie.durata_anni: Copia in «Atti generali»: …)».
 *
 * Il campo puo' mancare: un validatore che guarda piu' campi insieme non ne
 * indica uno solo, e stampare `campo` senza controllarlo produceva «null: ...».
 */
export function messaggioConDettagli(
  messaggio: string,
  dettagli: readonly DettaglioErrore[],
): string {
  const violazioni = dettagli
    .filter((dettaglio) => !messaggio.includes(dettaglio.messaggio))
    .map((dettaglio) =>
      dettaglio.campo ? `${dettaglio.campo}: ${dettaglio.messaggio}` : dettaglio.messaggio,
    );
  return violazioni.length === 0 ? messaggio : `${messaggio} (${violazioni.join("; ")})`;
}
